<p-toast>
    <ng-template let-message pTemplate="message">
        <div class="p-toast-message-icon">
            <span
                [class]="
                    'p-toast-message-icon pi' +
                    (message.severity === 'success'
                        ? ' pi-check'
                        : message.severity === 'info'
                          ? ' pi-info-circle'
                          : message.severity === 'warn'
                            ? ' pi-exclamation-triangle'
                            : message.severity === 'error'
                              ? ' pi-times-circle'
                              : '')
                "
            >
            </span>
        </div>
        <div class="message-body">
            <div class="p-toast-message-text">
                @if (message.summary) {
                    <span class="p-toast-summary">{{ message.summary }}</span>
                }
                @if (message.detail) {
                    <div class="p-toast-detail" [innerHtml]="message.detail"></div>
                }
            </div>
        </div>
    </ng-template>
</p-toast>
